<div class="app-layout">
  <!-- Header - tylko gdy nie jesteśmy na stronie logowania -->
  <app-header class="app-header" *ngIf="!isLoginPage"></app-header>

  <!-- Main content area -->
  <div class="app-main" [class.with-sidebar]="!isLoginPage">
    <!-- Sidebar - tylko gdy nie jesteśmy na stronie logowania -->
    <mat-sidenav-container class="example-container">
      <mat-sidenav #sidenav mode="side" [opened]="app.isSideNavOpen()">
        <app-sidebar class="app-sidebar" *ngIf="!isLoginPage"></app-sidebar>
      </mat-sidenav>

      <mat-sidenav-content>
        <!-- Page content -->
        <main class="app-content" [class.full-width]="isLoginPage">
          <router-outlet />
        </main>

      </mat-sidenav-content>
    </mat-sidenav-container>


  </div>
</div>